import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=557660af&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557660af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('557660af')) {
      api.createRecord('557660af', component.options)
    } else {
      api.reload('557660af', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=557660af&scoped=true&", function () {
      api.rerender('557660af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2krZg6Jo0mMRl/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports